import { Project, ProjectInterface } from "../project/project.model";
import { Results, ResultsInterface } from "./results.model";

/** Corresponds (partial) with adaresults from the backend */
export interface AdaResultSetInterface {
  'project-state': ProjectInterface;
  results: ResultsInterface;
};

export class AdaResultSet {
  'project-state': Project;
  results: Results;

  constructor(param: AdaResultSetInterface) {
    this.results = new Results(param.results);
    this['project-state'] = new Project(param['project-state']);
  }
};